import { DESKTOP_MAX_SIZE } from "@/constants/screen";
import { SvgError404Illustration } from "@getgrover/ui";
import styled from "styled-components";

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: ${({ theme }) => theme.spacers.L};
`;

export const Content = styled.div`
  text-align: center;
  justify-items: center;
  max-width: ${DESKTOP_MAX_SIZE};
`;

export const Title = styled.h1`
  ${({ theme }) => theme.typography.MediumHeadline};
  margin-bottom: ${({ theme }) => theme.spacers.M};
`;

export const Description = styled.p`
  ${({ theme }) => theme.typography.RegularParagraph};
  margin-bottom: ${({ theme }) => theme.spacers.L};
`;

export const Error404Illustration = styled(SvgError404Illustration)`
  width: calc(${DESKTOP_MAX_SIZE} - 10px);
  height: 200px;
`;
